import { call, put, select, takeLatest } from 'redux-saga/effects'
import { request } from 'utils/request'
import { applicationManagementComponentActions } from '.'
import { selectAuth } from '../../LoginFormComponent/slice/selectors'

export function* registerUserSaga(actions) {
  const {
    appointmentId,
    locationId,
    values,
    navigate,
    registrationSuccessURL,
    path,
    alreadyRegisteredUser
  } = actions.payload

  // Filter payload.
  const newPayload = {}
  for (const key in values) {
    if (
      values.hasOwnProperty(key) &&
      key !== 'passwordConfirmation' &&
      key !== 'gdpr' &&
      values[key] !== ''
    ) {
      newPayload[key] = values[key]
    }
  }

  // Add educational center.
  newPayload['locationId'] = locationId

  // Add date.
  newPayload['appointmentId'] = appointmentId

  // If user is already logged in?
  const auth = yield select(selectAuth)

  try {
    const requestURL = `${process.env.GATSBY_DIRECTUS}/api1.0/user/apply`
    yield call(request, requestURL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        ...(auth &&
          alreadyRegisteredUser && {
            Authorization: `Bearer ${auth.accessToken}`
          })
      },
      body: JSON.stringify(newPayload)
    })

    yield call(navigate, `${path}/${registrationSuccessURL}`, {
      preventScrollReset: false
    })
    yield put(applicationManagementComponentActions.reset())
  } catch (e: any) {
    if (e.response.status === 400) {
      yield put(
        applicationManagementComponentActions.setRegistrationFormAsyncErrors({
          email: '__ERROR_USER_ALREADY_EXISTS__'
        })
      )
    } else if (e.response.status === 401) {
      yield put(
        applicationManagementComponentActions.setRegistrationFormAsyncErrors({
          password: '__PASSWORD_WRONG__'
        })
      )
    } else {
      yield put(applicationManagementComponentActions.reset())
    }
  } finally {
    yield put(applicationManagementComponentActions.setIsLoading(false))
  }
}

export function* loadAndSetUserDataSaga() {
  const auth = yield select(selectAuth)

  try {
    if (!auth) {
      throw new Error('__ERROR__')
    }

    const requestURL = `${process.env.GATSBY_DIRECTUS}/users/me`
    const response = yield call(request, requestURL, {
      headers: {
        Authorization: `Bearer ${auth.accessToken}`,
        'Content-Type': 'application/json'
      }
    })

    const userData = {
      first_name: response.data.first_name,
      last_name: response.data.last_name,
      city: response.data.city,
      country: response.data.country,
      national_code: response.data.national_code,
      country_code: response.data.country_code,
      connection_identifier: response.data.connection_identifier,
      street: response.data.street,
      zip_code: response.data.zip_code,
      website: response.data.website,
      job: response.data.job,
      email: response.data.email,
      newsletter: response.data.newsletter,
      id: response.data.id
    }

    yield put(applicationManagementComponentActions.setUserData(userData))
  } catch (err: unknown) {
    throw err
  } finally {
    yield put(applicationManagementComponentActions.setIsLoadingUserData(false))
    yield put(applicationManagementComponentActions.setIsLoading(false))
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* applicationManagementComponentSaga() {
  yield takeLatest(
    applicationManagementComponentActions.registerUser.type,
    registerUserSaga
  )
}
